import React from 'react'
import CollectionOrderPortalFormPageContainer from './CollectionOrderPortalFormPageContainer';

export class CollectionOrderPortalFormPage extends React.Component{
    render(){
        return (
            <CollectionOrderPortalFormPageContainer { ...this.props } />
        )
    }
}